module.exports = __webpack_public_path__ + "static/media/bebe.7940877d.jpeg";